import React from 'react';
import Tippy from '@tippyjs/react';
import useUser from '../hooks/useUser';

const ViewerAvatar = (props) => {
    const {
        user,
        userId,
        tooltipPrefix = '',
        you = false,
        tooltipSuffix = '',
    } = props;
    const avatarUser = user ?? useUser(userId);

    if (!avatarUser) return null;

    const userPart = you ? 'you' : avatarUser.display_name;
    const suffixPart = tooltipSuffix ? (you ? 'your' : `${avatarUser.display_name}'s`) + tooltipSuffix : '';
    const tooltip = `${tooltipPrefix}${userPart}${suffixPart}`;

    return (
        <Tippy content={tooltip} placement="bottom">
            <img
                className="viewer__avatar"
                src={avatarUser.image_192}
                width="24"
                height="24"
                alt={tooltip}
            />
        </Tippy>
    );
};

export default ViewerAvatar;
